<script>
import { makeEmailSenderDefault, deleteEmailSender } from "@/api/accounts.js";
import AddEmailSender from "@/view/components/accounts/EmailSenderDetail.vue";
export default {
  name: "email-sender",
  components: {
    AddEmailSender
  },
  data() {
    return {
      search: "",
      selected: [],
      headers: [
        {
          text: "Email",
          align: "left",
          sortable: true,
          value: "email"
        },
        { text: "Default", value: "default" },
        { text: "Action", value: "action" }
      ],
      items: [],
      item: null,
      snackbar: false,
      text: "Loading email senders...",
      timeout: 2000,
      loading: true,
      dialogRemove: false,
      dialogMsg: ""
    };
  },
  async mounted() {
    this.$store.dispatch("getEmailSenders");
  },
  computed: {
    getEmailSenders() {
      return this.$store.getters["getEmailSenders"];
    }
  },
  watch: {
    getEmailSenders(newValue) {
      this.items = newValue;
      this.loading = false;
    }
  },
  methods: {
    async emailDefault(item) {
      const payload = JSON.parse(
        JSON.stringify({ email: this.email, default: true })
      );
      await makeEmailSenderDefault(item.id, payload);
      this.$store.dispatch("getEmailSenders");
    },
    async emailRemove(item) {
      this.item = item;
      this.dialogMsg = `Remove ${item.email} ?`;
      this.dialogRemove = true;
    },
    async removeConfirm() {
      let item = this.item;
      this.item = null;
      this.dialogRemove = false;
      await deleteEmailSender(item.id);
      this.$store.dispatch("getEmailSenders");
    },
    closeDelete() {
      this.item = null;
      this.dialogRemove = false;
    },
    defaultValue(value) {
      return value ? "Yes" : "No";
    }
  }
};
</script>

<template>
  <v-card>
    <v-card-title>Validated Email</v-card-title>
    <div class="text-muted p-5">
      Your emails will be sent from this email address. Please insert an email
      address and Aben will validate it within 24 hours. Your email must be
      validated before you can send any emails
    </div>
    <AddEmailSender />
    <hr />
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      item-key="id"
      class="elevation-1"
      :search="search"
      :loading="loading"
      loading-text="Loading... Please wait"
    >
      <template v-slot:loading>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </template>
      <template v-slot:item.default="{ item }">
        <i v-if="item.default" class="flaticon2-check-mark text-success"></i>
      </template>

      <template v-slot:item.action="{ item }">
        <div v-if="item.default" class="text-muted">
          Make Default | Delete
        </div>
        <div v-if="!item.default">
          <a href="#" @click.prevent="emailDefault(item)">Make Default</a> |
          <a href="#" v-if="!item.default" @click.prevent="emailRemove(item)">
            Delete
          </a>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogRemove" max-width="510px">
      <v-card>
        <v-card-title class="headline">{{ dialogMsg }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="removeConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
